import dayjs from "dayjs";
import User from "./models/UserModel";



export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertTo12HourFormat(time24) {
  const [hours, minutes] = time24.split(":");
  let period = "AM";

  // Convert to 12-hour format
  let hours12 = parseInt(hours, 10);
  if (hours12 >= 12) {
    period = "PM";
    if (hours12 > 12) {
      hours12 -= 12;
    }
  }

  // Add leading zeros to minutes if needed
  const minutesWithLeadingZero = String(minutes).padStart(2, "0");

  return `${hours12}:${minutesWithLeadingZero} ${period}`;
}


export function getPanelFormatedDateTimeFromDateStr(string){
  return dayjs(string).format(' hh:mm a, MMMM DD, YYYY ');
}


// Example usage:
const time24Hour = "17:11:02";
const time12Hour = convertTo12HourFormat(time24Hour);
console.log(time12Hour); // Output: "5:11 PM"

export const getUserListFromJsonArray=(dataArray)=> {
    const userDataArray = dataArray.map((data) => new User(data));
    userDataArray.forEach((user) => {
      console.log(user.firstName, user.lastName, user.email, user.userType);
    });
  
    return userDataArray;
  }


  export function formatDecimalValue(a) {

    
   var value = Math.floor(a / 100);



    const suffixes = {
      K: 1e3,
      M: 1e6,
      B: 1e9,
      T: 1e12,
    };
  
    const suffixKeys = Object.keys(suffixes).reverse();
  
    for (const suffix of suffixKeys) {
      if (Math.abs(value) >= suffixes[suffix]) {
        return (value / suffixes[suffix]).toFixed(1) + suffix;
      }
    }
  
    return value.toString();
  }
  

  export function convertDecimalValue(value) {
    const suffixes = {
      K: 1e3,
      M: 1e6,
      B: 1e9,
      T: 1e12,
    };
  
    const regex = /^(\d+\.?\d*)([KMBT])$/i;
    const match = value.match(regex);
  
    if (!match) {
      throw new Error('Invalid input format. Expected format: "10M", "1K", "2B", etc.');
    }
  
    const number = parseFloat(match[1]);
    const suffix = match[2].toUpperCase();
  
    if (!suffixes.hasOwnProperty(suffix)) {
      throw new Error(`Unsupported suffix '${suffix}'. Supported suffixes are K, M, B, and T.`);
    }
  
    return number * suffixes[suffix];
  }
  
  
  
  
  
  